import {
  Component,
} from "react";
import {
  autoUpdate,
  computePosition,
  flip,
  offset,
  shift,
} from "@floating-ui/dom";
import {
  FormControl,
} from "react-bootstrap";
import {
  createPortal,
} from "react-dom";
import {
  Link,
} from "react-router-dom";

import store from "CommonState/store";
import {
  Awesome,
} from "CommonComponents/bricks";
import helpApi, {
  articleToAnchor,
  searchDataSelector,
  searchResultsSelector,
} from "Apis/help-api";

import _ from "lodash";

class GlyphPlaceholderFormControl extends Component {
  render() {
    const { glyph, placeholder } = this.props;

    return (
      <span style={{ position: "relative", display: "inline-block" }}>
        <Awesome
          name={glyph} style={{
            position: "absolute",
            margin: "0.5em",
            pointerEvents: "none",
            fontSize: "125%",
          }} />
        <FormControl
          style={{ paddingLeft: "2.2em" }}
          placeholder={placeholder}
          {...this.props} />
      </span>
    );
  }
}

@store(searchDataSelector, searchResultsSelector)
class SearchResultsBox extends Component {
  render() {
    const { searchResults, onClose } = this.props;
    return (
      <div className='search-bar-results-box'>
        {
          _.map(searchResults, entry => (
            <div key={entry.hi_id}>
              <Link
                onClick={onClose}
                to={`/hilfe#${ articleToAnchor(entry) }`}
              >
                {entry.hi_titel}
              </Link>
            </div>
          ))}
        {_.isEmpty(searchResults) && <em>Keine Ergebnisse wurden gefunden.</em>}
      </div>
    );
  }
}

@helpApi.list
export default class SearchBar extends Component {
  constructor() {
    super();
    this.state = {
      floatingStyle: {
        left: 0,
        position: "fixed",
        top: 0,
      },
    };
  }

  render() {
    const { open, searchText, floatingStyle } = this.state;
    const showResults = open && _.isString(searchText) && searchText.length >= 2;

    return (
      <>
        <span ref={this.setReferenceRef}>
          <GlyphPlaceholderFormControl
            glyph='question'
            placeholder='Hilfe durchsuchen'
            onChange={this.onChange}
            onFocus={this.onFocus}
          />
        </span>
        {showResults && createPortal(
          <div
            ref={this.setFloatingRef}
            style={floatingStyle}>
            <SearchResultsBox
              searchText={searchText}
              onClose={this.onClose} />
          </div>,
          document.body,
        )}
      </>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { open, searchText } = this.state;
    const showResults = open && _.isString(searchText) && searchText.length >= 2;
    const prevShowResults = prevState.open && _.isString(prevState.searchText) && prevState.searchText.length >= 2;

    if (showResults && !prevShowResults) {
      this.attachFloating();
    } else if (!showResults && prevShowResults) {
      this.detachFloating();
    } else if (showResults) {
      this.updateFloatingPosition();
    }
  }

  componentWillUnmount() {
    this.detachFloating();
  }

  onChange = ({ target }) => {
    const searchText = target.value;
    this.setState({ searchText });
  };

  onFocus = () => {
    this.setState({ open: true });
  };

  onClose = () => {
    this.setState({ open: false });
  };

  onDocumentMouseDown = evt => {
    const {
      referenceElement,
      floatingElement,
    } = this;

    if (
      (referenceElement && referenceElement.contains(evt.target))
      || (floatingElement && floatingElement.contains(evt.target))
    ) {
      return;
    }

    this.onClose();
  };

  onDocumentKeyDown = evt => {
    if (evt.key === "Escape") {
      this.onClose();
    }
  };

  setReferenceRef = element => {
    this.referenceElement = element;
    this.updateFloatingPosition();
  };

  setFloatingRef = element => {
    this.floatingElement = element;
    this.updateFloatingPosition();
  };

  attachFloating() {
    if (!this.referenceElement || !this.floatingElement) {
      return;
    }

    this.cleanupAutoUpdate = autoUpdate(
      this.referenceElement,
      this.floatingElement,
      this.updateFloatingPosition,
    );
    document.addEventListener("mousedown", this.onDocumentMouseDown);
    document.addEventListener("keydown", this.onDocumentKeyDown);
    this.updateFloatingPosition();
  }

  detachFloating() {
    if (this.cleanupAutoUpdate) {
      this.cleanupAutoUpdate();
      this.cleanupAutoUpdate = null;
    }
    document.removeEventListener("mousedown", this.onDocumentMouseDown);
    document.removeEventListener("keydown", this.onDocumentKeyDown);
  }

  updateFloatingPosition = () => {
    if (!this.referenceElement || !this.floatingElement) {
      return;
    }

    computePosition(this.referenceElement, this.floatingElement, {
      placement: "bottom-end",
      strategy: "fixed",
      middleware: [
        offset(4),
        flip(),
        shift({ padding: 8 }),
      ],
    }).then(({ x, y, strategy }) => {
      const {
        floatingStyle,
      } = this.state;
      if (
        floatingStyle.left === x
        && floatingStyle.top === y
        && floatingStyle.position === strategy
      ) {
        return;
      }

      this.setState({
        floatingStyle: {
          left: x,
          position: strategy,
          top: y,
        },
      });
    });
  };
}
